import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { ChevronRight } from '@mui/icons-material';
import { useTimezone } from '@uplift/contexts';
import { useL10n } from '@uplift/hooks';
import { Button } from '../../../../../Button';
import { LoadableTypography } from '../../../../../LoadableTypography';
import { InfoRow } from '../InfoRow';
import { InfoSection } from '../InfoSection';
import { formatDateTimeRange } from '@uplift/services';


const useStyles = makeStyles()(theme => ({
  disabledLabel: {
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
  }
}));


export type SectionPreviousSessionProps = {
  loading: boolean;
  onReviewNotes: () => void;
  previousAppointment?: {
    id: string;
    fromDatetime: string;
    toDatetime: string;
  } | null;
};


export const SectionPreviousSession: React.FC<SectionPreviousSessionProps> = ({ loading, ...props }) => {
  const l10n = useL10n();
  const timezone = useTimezone();
  const { classes } = useStyles();

  const previousSessionRange = React.useMemo(() => {
    if (loading) {
      return (
        <LoadableTypography width="200px" loading />
      );
    }

    if (!props.previousAppointment?.fromDatetime) {
      return (
        <Typography className={classes.disabledLabel}>
          {l10n.sessions.noPreviousSession}
        </Typography>
      );
    }

    return (
      <Typography>
        {formatDateTimeRange(props.previousAppointment.fromDatetime, props.previousAppointment.toDatetime, timezone)}
      </Typography>
    );
  }, [ props.previousAppointment, timezone, loading, l10n, classes.disabledLabel ]);


  return (
    <InfoSection title={l10n.sessions.detailsModal.previousSession}>
      <Box display="flex">
        <Box display="flex" flex="1">
          <InfoRow label="Date">
            {previousSessionRange}
          </InfoRow>
        </Box>
        <Box display="flex" alignItems="flex-end">
          <Button
            color="secondary"
            size="small"
            endIcon={<ChevronRight />}
            onClick={props.onReviewNotes}
            disabled={!props.previousAppointment?.id}
          >
            {l10n.sessions.reviewNotes}
          </Button>
        </Box>
      </Box>
    </InfoSection>
  );
};
